export default "__VITE_ASSET__DXsM6I$F__"